import styled from "@emotion/styled";

import { ellipsise, PanelDragItem, SkiliticsIcon } from "@skilitics/designer-ui-components";
import { useDragOperation } from "@skilitics/drag-drop";

import { draggableDataSchema } from "../dnd/dndSchemas";

export const DragOverlayDragItem = () => {
  const { source } = useDragOperation();

  const activeItemData = draggableDataSchema.safeParse(source?.data);

  if (activeItemData.success) {
    const {
      title,
      rule: { ruleType },
    } = activeItemData.data;

    const style = { cursor: "grabbing" };

    const className = ruleType === "condition" ? "purple" : "orange";

    return (
      <PanelDragItem className={className} style={style}>
        <SkiliticsIcon icon={ruleType === "condition" ? "condition" : "effect-action"} />
        <Title>{title}</Title>
      </PanelDragItem>
    );
  }
};

const Title = styled.span`
  ${ellipsise}
`;
